import React, { ReactNode, cloneElement, isValidElement, useEffect, useState } from 'react';
import { useSubMenu } from './SubMenuContext';
import { twMerge } from 'tailwind-merge';
import { makeID } from './lib/utils';
import NovoButton from './ui/NovoButton';

interface ItemSubProps {
	children: ReactNode;
	id?: string;
	asChild?: boolean;
	onClick?: React.MouseEventHandler<Element>;
	className?: string;
	draggable?: boolean;
	isNew?: boolean;
}

const ItemSub = ({ children, id, asChild = false, className, isNew, ...props }: ItemSubProps) => {
	const { state, toggle, setSubId, clearSub } = useSubMenu();
	const [menuRandomID, setMenuRandomID] = useState('');

	useEffect(() => {
		setMenuRandomID(makeID());
	}, []);

	const handleClick: React.MouseEventHandler<Element> = (event) => {
		setSubId?.(menuRandomID);

		// se estiver abrindo um terceiro menu, ele vai remover o ativo do sub
		if (id) {
			toggle(id);
			clearSub?.();
		}

		if (props.onClick) {
			props.onClick(event);
		}
	};

	const isSubMenuActive = state?.subIdActive === menuRandomID;

	const defaultClasses = `w-full flex items-start justify-center flex-shrink-0`;
	const buttonDefaultClasses = `w-full flex-shrink-0 h-9 text-left py-0 px-1 break-normal whitespace-nowrap text-gray-900 font-medium text-xs rounded-lg hover:bg-gray-100 cursor-pointer ${isSubMenuActive ? 'bg-gray-100' : ''} outline-none`;
	const childClasses = `h-full flex items-center justify-start pl-10  ${isNew ? 'justify-between' : ''}`;

	if (asChild && isValidElement(children)) {
		return cloneElement(children as React.ReactElement<ItemSubProps>, {
			onClick: handleClick,
			className: defaultClasses,
			children: (
				<button className={twMerge(buttonDefaultClasses, className)}>
					<div className={childClasses}>{(children as React.ReactElement<ItemSubProps>).props.children} {isNew ? <NovoButton /> : null}</div>
				</button>
			),
			draggable: false,
			...props,
		});
	}

	return (
		<div onClick={handleClick} className={defaultClasses}>
			<button className={twMerge(buttonDefaultClasses, className)}>
				<div className={childClasses}>
					{children} {isNew ? <NovoButton /> : null}
				</div>
			</button>
		</div>
	);
};

export default ItemSub;
